import * as React from "react";
import { useTranslation } from "react-i18next";
import { Select } from "components/common";
import capabilityLabel from "logic/permissions/capabilityLabel";
const _capabilitiesOptions = (capabilities) => capabilities.map((capability) => ({ label: capabilityLabel(capability.title), value: capability.id })).toJS();
const EntityCreateCapabilitySelect = ({
  capabilities,
  onChange,
  value,
  title = void 0,
  ...rest
}) => {
  const { t } = useTranslation("users");
  const capabilitiesOptions = _capabilitiesOptions(capabilities);
  return /* @__PURE__ */ React.createElement(
    Select,
    {
      clearable: false,
      onChange,
      options: capabilitiesOptions,
      placeholder: title != null ? title : t("permissions.select_capability"),
      value,
      ...rest
    }
  );
};
export default EntityCreateCapabilitySelect;
